<template>
  <div class="themeEditorContainer">
      Hello, world.
  </div>
</template>

<script>
export default {
  props: ['bgColor', 'fontColor', 'fontColor2',  'logo', 'background'],
  data: function() {
    return {
      colorBackground: this.props.bgColor,
      colorFont: this.props.fontColor,
      colorFont2: this.props.fontColor2,
      logoURL: this.props.logo,
      backgroundURL: this.props.background,
    };
  },
  mounted: function() {
    console.log('Theme editor is mounted');
  }
}
</script>